import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef
} from '@angular/core';
import { ValidatorFn, Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { ModalService } from 'src/shared-app-portal/services/modal.service';

@Component({
  selector: 'app-editable-labeled-simple-text',
  templateUrl: './editable-labeled-simple-text.component.html',
  styleUrls: ['./editable-labeled-simple-text.component.scss'],
  standalone: false
})
export class EditableLabeledSimpleTextComponent implements OnInit {
  public isEditMode: boolean;
  editForm: FormGroup<{
    description: FormControl<string>;
  }>;

  @Input()
  public validators: ValidatorFn[] = null;
  @Input()
  public readOnly: boolean = false;
  @Input()
  public clickToEdit: boolean = false;

  @Input()
  public description: string;
  @Input()
  public fieldName: string = 'field';
  @Input()
  public label: string;
  @Input()
  public showSmallLabel: boolean = false;

  public get fieldLabelId(): string {
    return `editable-labeled-simple-text-${this.fieldName.replace(/\s+/g, '-').toLowerCase()}-label`;
  }

  @Output()
  public save = new EventEmitter<string>();

  // It's not clear why the autoFocus directive is not working
  // in this case. This essentially duplicates that directive
  // in this component.
  @ViewChild('description', { static: false })
  public set descriptionField(value: ElementRef) {
    setTimeout(() => {
      if (value) {
        value.nativeElement.focus();
      }
    }, 250);
  }

  constructor(
    private formBuilder: FormBuilder,
    private modalService: ModalService
  ) {}

  ngOnInit() {
    this.isEditMode = false;
  }

  onSaveClicked() {
    if (!this.editForm.valid) {
      this.editForm.markAllAsTouched();
      return;
    }
    let newDescription = this.editForm.value.description?.trim();
    this.save.emit(newDescription);
    this.isEditMode = false;
  }

  onDeleteClicked = async () => {
    const isSuccessful = await this.modalService.openDeleteModal(this.label);
    if (isSuccessful) {
      this.save.emit(null);
    }
  };

  cancelEditMode = () => {
    this.isEditMode = false;
  };
  enterEditMode() {
    this.isEditMode = true;

    const validators: ValidatorFn[] = [
      Validators.required,
      ...(this.validators ? this.validators : [])
    ];

    this.editForm = this.formBuilder.group({
      description: [this.description, validators]
    });
  }
}
